<template>
  <div class="main">

    <v-flex xs12 class="mb-4 pb-3">
      <!-- <v-toolbar fixed dense class="toolbar"> -->
      <v-toolbar fixed dense color="white">
        <v-btn icon light to="/">
          <v-icon color="grey darken-2">arrow_back</v-icon>
        </v-btn>
        <v-toolbar-title class="grey--text text--darken-4 text-xs-center tklogo">T K</v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- <v-btn icon light><v-icon color="grey darken-2">search</v-icon></v-btn> -->
        <v-btn active-class icon to="/">
          <v-tooltip color="blue" nudge-left="30px" bottom>
            <v-icon slot="activator" color="black" dark>fa fa-home</v-icon>
            <span>Back to Home</span>
          </v-tooltip>
        </v-btn>
        <v-btn flat round icon :href="facebook" target="_blank">
          <v-tooltip color="blue" nudge-left="30px" bottom>
          <v-icon slot="activator" color="black" medium>fab fa-facebook-square</v-icon>
            <span>Visit Us on Facebook</span>
          </v-tooltip>
        </v-btn>
      </v-toolbar>
    </v-flex>

    <v-container fluid grid-list-xs>

      <v-layout wrap>
        <v-flex offset-sm3 xs6 hidden-sm-and-down class="pr-4 pl-3">
           <v-text-field
             clearable
             hint="Enter the cat name for your search (max 50 characters). Results will display below."
             v-model="tksearch"
             class="v-card-border pb-0 mb-2 pl-2 pr-1 filter-bkgnd"
             label="Search By Name"
             color="blue"
             counter="50"
             maxlength="50"
             :rules="[rules.counter]"
           >
             <v-fade-transition slot="append">
               <v-img class="mb-2 pa-0" width="85" height="28" :src="require(`@/img/${tklogo}`)"></v-img>
             </v-fade-transition>
           </v-text-field>
         </v-flex>
         <v-flex xs12 hidden-md-and-up class="pr-3 pl-3">
           <v-text-field
             clearable
             hint="Enter the cat name for your search (max 50 characters). Results will display below."
             append-icon="search"
             v-model="tksearch"
             class="v-card-border pb-0 mb-2 pl-1 pr-1"
             label="Search By Name"
             color="blue"
             counter="50"
             maxlength="50"
             :rules="[rules.counter]"
           >
             <v-fade-transition slot="append">
               <v-img class="mb-2 pa-0" width="85" height="28" :src="require(`@/img/${tklogo}`)"></v-img>
             </v-fade-transition>
           </v-text-field>
         </v-flex>
      </v-layout>

      <v-layout wrap justify-center>
          <v-flex xs12 sm6 md4 lg3 xl2 v-for="(tkcat, index) in tkavatar" :key="index">
              <v-card color="grey lighten-4 ma-1" class="v-card-border black--text" hover elevation-24>
                <v-layout>

                  <!-- Picture -->
                  <router-link class="rtlnk" :to="{name: 'TkProfileView', params: {tkid: tkcat.tkid} }">
                    <!-- <v-flex xs3 class="pl-3 pr-0 ma-0"> -->
                    <v-flex xs3 class="pa-0 ma-0" style="padding: 6px;">
                      <!-- <v-avatar size="120"><v-img :src="require(`@/img/${tkcat.avatar}`)"></v-img></v-avatar> -->
                      <!-- The tile will remove the circle around the images and leave it with squares. -->
                      <v-avatar tile size="125"><v-img style="border-radius: 2px;" :src="require(`@/img/${tkcat.avatar}`)"></v-img></v-avatar>
                      <!-- <v-img height="110" width="110" :src="require(`@/img/${tkcat.avatar}`)"></v-img> -->
                    </v-flex>
                  </router-link>

                  <!-- Name and Links to Social Media -->
                  <v-flex xs9>
                    <v-card-title primary-title class="pa-0 ma-0">
                      <!-- <v-divider vertical inset class="pl-3"></v-divider> -->
                      <div class="pl-4">
                        <router-link class="rtlnk" :to="{name: 'TkProfileView', params: {tkid: tkcat.tkid} }">
                          <div class="thetkname" v-html="tkcat.tkname"></div>
                          <div class="pl-1 ma-0 pb-1" style="color: black;" v-html="tkcat.tkinfo"></div>
                        </router-link>
                      </div>

                      <div class="pl-2">
                      <v-divider class="pr-5 pl-2"></v-divider>
                        <v-card-actions class="pa-0 ma-0">
                          <v-btn icon>
                            <v-tooltip color="blue" nudge-down="10px" nudge-left="50px" bottom>
                              <!-- <v-icon slot="activator" color="black">favorite</v-icon> -->
                              <v-icon slot="activator" color="blue">favorite</v-icon>
                              <span>Add <span class="fluppercase">{{ tkcat.tkname }}</span> as a favorite. This feature is soon to come.</span>
                            </v-tooltip>
                          </v-btn>
                          <v-btn icon>
                            <v-tooltip color="blue" nudge-down="10px" nudge-left="65px" bottom>
                              <!-- <v-icon slot="activator" color="black">bookmark</v-icon> -->
                              <v-icon slot="activator" color="blue">bookmark</v-icon>
                              <span>Bookmark <span class="fluppercase">{{ tkcat.tkname }}</span>. This feature is soon to come.</span>
                            </v-tooltip>
                          </v-btn>
                          <v-btn icon>
                            <v-tooltip color="blue" nudge-down="10px" nudge-left="110px" bottom>
                              <!-- <v-icon slot="activator" color="black">fab fa-facebook-square</v-icon> -->
                              <v-icon slot="activator" color="blue">fab fa-facebook-square</v-icon>
                              <span>Post <span class="fluppercase">{{ tkcat.tkname }}</span> on Facebook. This feature is soon to come.</span>
                            </v-tooltip>
                          </v-btn>
                          <v-btn icon>
                            <v-tooltip color="blue" nudge-down="10px" nudge-left="110px" bottom>
                              <!-- <v-icon slot="activator" color="black">fab fa-twitter-square</v-icon> -->
                              <v-icon slot="activator" color="blue">fab fa-twitter-square</v-icon>
                              <span>Post <span class="fluppercase">{{ tkcat.tkname }}</span> on Facebook. This feature is soon to come.</span>
                            </v-tooltip>
                          </v-btn>
                        </v-card-actions>
                      </div>
                    </v-card-title>
                  </v-flex>

                </v-layout>
              </v-card>
          </v-flex>
      </v-layout>
    </v-container>

    <!-- TESTING GETTING ID, TKNAME, AND AVATAR FROM STORE -->
    <!-- <v-btn @click="getids">Click to get IDs</v-btn> -->

    <!-- Back to top button. Show on mobile/ipad only -->
    <div class="hidden-md-and-up">
      <v-btn
        id="scrolltotop"
        bottom fab fixed right small dark elevation-24
        color="transparent"
        class="back-to-top"
        style="color: blue;"
        slot="activator"
        v-on:click="scrollToTop"
      ><v-icon medium>keyboard_arrow_up</v-icon>
      </v-btn>
    </div>

    <v-container>
      <v-layout class="footer">
        <footer-view></footer-view>
      </v-layout>
    </v-container>

  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex'
import TkProfileView from "./TkProfileView";
import FooterView from "./FooterView";
import TkHeaderView from "./TkHeaderView";

export default {
  components: {
    TkProfileView,
    FooterView,
    TkHeaderView
  },
  data: () => ({
    title: 'TK Logo',
    facebook: 'https://www.facebook.com/timmyskittys1',
    tklogo: 'sebastian_logo_layer_at_1440x1105.png',
    tksearch: '',
    tkfilterCategory: 'all',
    rules: {
      counter: value => value.length <= 50 || 'Max 50 characters',
    },
    headers: [
        { text: '', value: '' },
        { text: '', value: '' },
        { text: '', value: '' },
      ],
  }),
  computed: {
    ...mapGetters([
      'getAllData'
    ]),
    tkavatar() {
      // console.log("tkavatar: " + JSON.stringify(this.getAllData[1]))  // For TESTING
      let alltkdata = this.getAllData
      if (this.tksearch) {
      	alltkdata = alltkdata.filter((tkcat) => {
        	return tkcat.tkname.indexOf(this.tksearch.toLowerCase()) !== -1
        })
      }
      return alltkdata
    },
    created () {
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
    }
  },
  methods: {
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: "smooth"
      });
    },
    handleScroll () {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        document.getElementById("scrolltotop").style.display = "block";
      } else {
        document.getElementById("scrolltotop").style.display = "none";
      }
      this.scrolled = window.scrollY > 0;
    }
  }
};
</script>

<style scoped>

.main {
  /* background-image: url("../img/white_silk_bkgrnd_1024x640.jpg"); */
  /* background-image: url("../img/white_wrinkled_silk_blue_1440x990.jpg"); */
  /* background-image: url("../img/white_wrinkled_silk_blue_1440x1190.jpg"); */
  /* background-color: #edf0fd; */
  /* background-color: #fefefa; */
  /* background-color: #f8f8ff; */
  background-color: #FFF;
  color: #1d2731;
  background-size: cover;
  width: 100%;
  height: 100%;
}
.filter-bkgnd {
  background-color: #F5F5F5;
}
.thepadding {
  padding-left: 20px;
}
.toolbar {
  background-color: #f8f8ff;
}
.v-card-border {
  border-radius: 2px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 1);
}
.thetkname {
  text-transform: capitalize;
  color: black;
  font-family: "Great Vibes", Arial, Helvetica, sans-serif;
  font-size: 2.6rem;
}
.tklogo {
  font-family: "Great Vibes", Arial, Helvetica, sans-serif;
  font-size: 2rem;
  font-weight: bold;
 }
.fluppercase {
  text-transform: capitalize;
}
.rtlnk {
  list-style-type: none;
  text-decoration: none;
}
.footer {
  margin-top: 10px;
}
@media screen and (max-width: 599px) {
  .footer {
    margin-top: 60px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/TkBioListView.vue